import { forwardRef } from 'react';

import type { IconProps } from './types';

export const DoubleChevronLeft = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <path
        d="M12.143 17.8695C12.2991 17.7605 12.4057 17.5941 12.4394 17.4067C12.4732 17.2193 12.4313 17.0261 12.323 16.8695L9.03146 12.138C9.00339 12.0977 8.98834 12.0498 8.98834 12.0008C8.98834 11.9517 9.00339 11.9038 9.03146 11.8635L12.323 7.13C12.432 6.97319 12.4742 6.77951 12.4404 6.59155C12.4066 6.40359 12.2995 6.23676 12.1427 6.12775C11.9859 6.01875 11.7922 5.9765 11.6043 6.0103C11.4163 6.04411 11.2495 6.15119 11.1405 6.308L7.84946 11.0395C7.65445 11.3214 7.54998 11.656 7.54998 11.9988C7.54998 12.3415 7.65445 12.6761 7.84946 12.958L11.1405 17.6895C11.1944 17.7672 11.2632 17.8334 11.3428 17.8845C11.4224 17.9356 11.5113 17.9705 11.6044 17.9872C11.6975 18.0039 11.793 18.0021 11.8854 17.9819C11.9778 17.9617 12.0653 17.9235 12.143 17.8695Z"
        fill={color}
      />
      <path
        d="M16.143 17.8695C16.2991 17.7605 16.4057 17.5941 16.4394 17.4067C16.4732 17.2193 16.4313 17.0261 16.323 16.8695L13.0315 12.138C13.0034 12.0977 12.9883 12.0498 12.9883 12.0008C12.9883 11.9517 13.0034 11.9038 13.0315 11.8635L16.323 7.13C16.432 6.97319 16.4742 6.77951 16.4404 6.59155C16.4066 6.40359 16.2995 6.23676 16.1427 6.12775C15.9859 6.01875 15.7922 5.9765 15.6043 6.0103C15.4163 6.04411 15.2495 6.15119 15.1405 6.308L11.8495 11.0395C11.6544 11.3214 11.55 11.656 11.55 11.9988C11.55 12.3415 11.6544 12.6761 11.8495 12.958L15.1405 17.6895C15.1944 17.7672 15.2632 17.8334 15.3428 17.8845C15.4224 17.9356 15.5113 17.9705 15.6044 17.9872C15.6975 18.0039 15.793 18.0021 15.8854 17.9819C15.9778 17.9617 16.0653 17.9235 16.143 17.8695Z"
        fill={color}
      />
    </svg>
  )
);

export default DoubleChevronLeft;
